<template>
  <v-row>
    <v-col class="px-0 px-sm-3">
      <v-container class="pa-0 pa-sm-3">
        <v-row>
          <v-col>
            <v-toolbar
              flat
              v-if="selectedCategoriasFinal.length"
              color="white darken-4"
              light
              height="auto"
              class="toolbar-seleccion"
            >
              <v-toolbar-title class="mr-2">
                <div :style="'font-size: 17px'">
                  {{
                    selectedCategoriasFinal.length === 1
                      ? "1 seleccionado"
                      : `${selectedCategoriasFinal.length} seleccionados`
                  }}
                </div>
              </v-toolbar-title>
              <v-divider class="ml-2 hidden-xs-only" vertical></v-divider>
              <v-btn
                :disabled="selectedCategoriasFinal.length < 2"
                text
                @click="setUnificarCategoria"
                v-if="!isUnificar"
              >
                Unificar
              </v-btn>
              <v-btn
                :disabled="selectedCategoriasFinal.length > 1"
                text
                @click="setEditarCategoria(selectedCategoriasFinal[0])"
                v-if="!isEdit"
              >
                Editar
              </v-btn>
              <v-btn
                :disabled="selectedCategoriasFinal.length > 1"
                text
                @click="setGestionarImagen(selectedCategoriasFinal[0])"
                v-if="!isUnificar && !isEdit"
              >
                Imagen
              </v-btn>
              <v-btn
                :disabled="selectedCategoriasFinal.length > 1"
                text
                @click="setEliminarCategoria(selectedCategoriasFinal[0])"
                v-if="!isUnificar"
              >
                Eliminar
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn icon @click="removeCategoria()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
          </v-col>
        </v-row>
        <v-card v-if="isEdit && categoriaEditSelected">
          <producto-categoria-update
            :categoria="categoriaEditSelected"
            @refresh-categorias="refreshCategoriaEditada"
            @cerrar-dialog="cerrarEdicion"
          ></producto-categoria-update>
        </v-card>
        <v-dialog v-if="categoriaEditSelected" v-model="isDelete" width="550">
          <v-card flat class="pa-4" color="#282828" elevation="2">
            <v-card-title class="text-h6 d-flex align-center">
              ¿Quieres borrar esta categoría permanentemente?
            </v-card-title>

            <v-card-text class="text-center mt-6">
              <v-list-item
                color="grey"
                class="justify-center"
                style="
                  background-color: rgba(255, 255, 255, 0.05);
                  border: 1px solid rgba(255, 255, 255, 0.1);
                "
              >
                <v-list-item-avatar>
                  <v-icon size="40">mdi-folder-outline</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title>
                    {{ categoriaEditSelected.name }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <!-- Checkbox de confirmación -->
              <v-checkbox
                v-model="confirmDelete"
                class="mt-6"
                color="grey lighten-1"
                label="Comprendo que borrar esta categoría es una acción que no se puede deshacer"
                hide-details
              />
            </v-card-text>

            <v-card-actions class="mt-6">
              <v-spacer></v-spacer>
              <v-btn rounded variant="text" @click="isDelete = false">
                Cancelar
              </v-btn>
              <v-btn
                rounded
                :disabled="!confirmDelete"
                :light="confirmDelete"
                @click="eliminarCategoria(categoriaEditSelected)"
              >
                Eliminar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-if="categoriaEditSelected" v-model="isImagen" width="460">
          <v-card color="#1e1e1e">
            <v-toolbar flat color="#2a2a2a" dense>
              <v-toolbar-title class="white--text">Imagen — {{ categoriaEditSelected.name }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="isImagen = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-card-text class="pt-4">
              <v-img
                v-if="categoriaEditSelected.imagen"
                :src="categoriaEditSelected.imagen"
                max-height="200"
                contain
                class="mb-4 grey darken-3 rounded"
              ></v-img>
              <div v-else class="d-flex align-center justify-center grey darken-3 rounded mb-4" style="height:120px;">
                <v-icon large color="grey">mdi-image-off</v-icon>
              </div>
              <v-file-input
                v-model="imagenFile"
                label="Seleccionar imagen"
                accept="image/*"
                outlined
                dense
                dark
                hide-details
                prepend-icon="mdi-image"
              ></v-file-input>
            </v-card-text>
            <v-card-actions>
              <v-btn
                v-if="categoriaEditSelected.imagen"
                text
                color="red lighten-1"
                :loading="loadingImagen"
                @click="eliminarImagen"
              >
                <v-icon left>mdi-delete</v-icon>Eliminar imagen
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn text color="grey" @click="isImagen = false">Cancelar</v-btn>
              <v-btn
                color="primary"
                :loading="loadingImagen"
                :disabled="!imagenFile"
                @click="subirImagen"
              >
                Guardar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-card color="#161616" flat v-if="isUnificar">
          <v-container>
            <v-card-title>
              <div class="mt-2">Unificar categorías</div>
            </v-card-title>
            <v-card-text>
              <v-text-field
                class="mt-4"
                v-model="nuevoNombreCategoria"
                v-validate="'required'"
                name="nombre de categoría"
                label="Nuevo nombre de categoría"
                outlined
                dense
                clearable
                :error-messages="errors.collect('nuevoNombreCategoria')"
              />
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                rounded
                :disabled="errors.any() || !nuevoNombreCategoria"
                @click="validateForm"
              >
                Unificar
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
        <v-divider></v-divider>

        <v-row class="px-3 mt-3 mb-1 align-center" no-gutters style="gap: 8px">
          <span class="text--secondary caption">Filtrar por uso:</span>
          <v-btn-toggle v-model="usoFiltro" mandatory dense>
            <v-btn value="todos" small>Todos</v-btn>
            <v-btn value="venta" small>
              <v-icon x-small left color="teal darken-1">mdi-circle</v-icon>
              Venta
            </v-btn>
            <v-btn value="compra" small>
              <v-icon x-small left color="orange darken-2">mdi-circle</v-icon>
              Compra
            </v-btn>
          </v-btn-toggle>
        </v-row>

        <v-row
          class="scroll-bar align-stretch d-flex flex-row flex-nowrap mt-2"
          ref="scrollContainer"
        >
          <!-- Una columna por nivel. En celular cada nivel ocupa casi todo el
               ancho y se desliza de a uno (queda asomando el siguiente). -->
          <v-col
            cols="11"
            sm="6"
            md="4"
            class="columna-nivel"
            v-for="comp in categoriasRenderizadas"
            :key="comp.categoria.id"
          >
            <span id="scrollFinal"></span>
            <component
              @processCategoria="fetchCategoria"
              :selectedCategoriasFinal="selectedCategoriasFinal"
              @update:selectedCategoriasFinal="seleccionarCategoria"
              :parent="comp.categoria"
              :is="comp.type"
              :usoFiltro="usoFiltro"
              :ref="'categoriaNivel' + comp.categoria.level_padre"
            ></component>
          </v-col>
          <!-- Skeleton Loader para carga -->
          <v-col v-if="loadingCategoriaSelected" cols="11" sm="6" md="4" class="columna-nivel">
            <v-skeleton-loader
              type="list-item-two-line"
              class="mb-2"
              v-for="n in 6"
              :key="n"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
import ProductoCategoriasTreeBranch from "@/components/producto/categorias/ProductoCategoriasTreeBranch.vue";
import ProductoCategoriaUpdate from "@/components/producto/categorias/ProductoCategoriaUpdate";

import CategoriaAPI from "@/api/categorias";
import ProductosApi from "@/api/productos";

export default {
  name: "",
  components: {
    ProductoCategoriasTreeBranch,
    ProductoCategoriaUpdate,
  },
  $_veeValidate: {
    validator: "new",
  },
  data() {
    return {
      selectedCategoriasFinal: [],
      categoriaPadre: [],
      categoriasRenderizadas: [],
      loadingCategoriaSelected: false,
      count: 0,
      isUnificar: false,
      nuevoNombreCategoria: "",
      isEdit: false,
      isDelete: false,
      isImagen: false,
      imagenFile: null,
      loadingImagen: false,
      confirmDelete: false,
      categoriaEditSelected: null,
      usoFiltro: 'todos',
    };
  },

  methods: {
    seleccionarCategoria(nuevoArrayCategorias) {
      if (nuevoArrayCategorias.length === 0) {
        this.selectedCategoriasFinal = [];
        return;
      }

      // Tomamos el nivel base de la primera categoría (la "correcta")
      const nivelBase = nuevoArrayCategorias[0].mptt_level;

      // Filtramos para quedarnos solo con las categorías del nivel base
      const filtradas = nuevoArrayCategorias.filter(
        (cat) => cat.mptt_level === nivelBase
      );

      if (filtradas.length < nuevoArrayCategorias.length) {
        // Había categorías fuera del nivel, avisamos
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          color: "info",
          text: "Solo podés elegir categorías del mismo tipo. Corregimos tu selección.",
          timeout: 3000,
        });
      }

      // Actualizamos solo con las categorías válidas
      this.selectedCategoriasFinal = filtradas;
    },
    setEditarCategoria(categoria) {
      if (!this.isEdit) {
        // Hacer una copia profunda para evitar modificar el objeto original
        this.categoriaEditSelected = categoria
          ? JSON.parse(JSON.stringify(categoria))
          : null;
      } else {
        this.categoriaEditSelected = null;
      }
      this.isEdit = !this.isEdit;
    },
    setEliminarCategoria(categoria) {
      if (!this.isDelete) {
        // Hacer una copia profunda para evitar modificar el objeto original
        this.categoriaEditSelected = categoria
          ? JSON.parse(JSON.stringify(categoria))
          : null;
      } else {
        this.categoriaEditSelected = null;
      }
      this.isDelete = !this.isDelete;
    },

    setGestionarImagen(categoria) {
      this.categoriaEditSelected = JSON.parse(JSON.stringify(categoria));
      this.imagenFile = null;
      this.isImagen = true;
    },
    async subirImagen() {
      if (!this.imagenFile) return;
      this.loadingImagen = true;
      const formData = new FormData();
      formData.append('imagen', this.imagenFile);
      try {
        const response = await CategoriaAPI.uploadImagen(this.categoriaEditSelected.id, formData);
        this.actualizarImagenEnBranch(this.categoriaEditSelected, response.data.imagen);
        this.imagenFile = null;
        this.isImagen = false;
        this.$updateBus.$emit("showSnackBar", {
          show: true, button: false, color: "success",
          text: "Imagen actualizada", icon: "mdi-check", timeout: 3000,
        });
      } catch {
        this.$updateBus.$emit("showSnackBar", {
          show: true, button: false, color: "error",
          text: "Error al subir la imagen", icon: "mdi-alert-circle", timeout: 3000,
        });
      } finally {
        this.loadingImagen = false;
      }
    },
    async eliminarImagen() {
      this.loadingImagen = true;
      try {
        await CategoriaAPI.deleteImagen(this.categoriaEditSelected.id);
        this.actualizarImagenEnBranch(this.categoriaEditSelected, null);
        this.isImagen = false;
        this.$updateBus.$emit("showSnackBar", {
          show: true, button: false, color: "success",
          text: "Imagen eliminada", icon: "mdi-check", timeout: 3000,
        });
      } catch {
        this.$updateBus.$emit("showSnackBar", {
          show: true, button: false, color: "error",
          text: "Error al eliminar la imagen", icon: "mdi-alert-circle", timeout: 3000,
        });
      } finally {
        this.loadingImagen = false;
      }
    },
    actualizarImagenEnBranch(categoria, nuevaImagen) {
      const refName = "categoriaNivel" + (categoria.mptt_level - 1);
      const cmpHijo = this.$refs[refName];
      const branches = Array.isArray(cmpHijo) ? cmpHijo : [cmpHijo];
      branches.forEach((branch) => {
        if (!branch) return;
        const idx = branch.categorias.findIndex((c) => c.id === categoria.id);
        if (idx !== -1) {
          this.$set(branch.categorias[idx], 'imagen', nuevaImagen);
        }
      });
      // Actualizar también en selectedCategoriasFinal para que el dialog se refresque
      const selIdx = this.selectedCategoriasFinal.findIndex(c => c.id === categoria.id);
      if (selIdx !== -1) {
        this.$set(this.selectedCategoriasFinal[selIdx], 'imagen', nuevaImagen);
      }
    },
    setUnificarCategoria() {
      this.isUnificar = !this.isUnificar;
      if (this.isUnificar) {
        this.nuevoNombreCategoria = this.selectedCategoriasFinal[0].name;
      }
    },
    refreshCategoriaEditada(categoriaActualizada) {
      this.categoriaEditSelected = null;
      this.selectedCategoriasFinal = [];

      // El branch que contiene esta categoría tiene level_padre = mptt_level - 1
      const refName = "categoriaNivel" + (categoriaActualizada.mptt_level - 1);

      this.$nextTick(() => {
        const cmpHijo = this.$refs[refName];
        const branches = Array.isArray(cmpHijo) ? cmpHijo : [cmpHijo];
        branches.forEach((branch) => {
          if (!branch) return;
          const idx = branch.categorias.findIndex((c) => c.id === categoriaActualizada.id);
          if (idx !== -1) {
            branch.categorias.splice(idx, 1, {
              ...branch.categorias[idx],
              name: categoriaActualizada.name,
              uso: categoriaActualizada.uso,
            });
          }
        });
      });
    },
    cerrarEdicion() {
      this.isEdit = false;
      this.selectedCategoriasFinal = [];
      this.categoriaEditSelected = null;
    },
    refreshCategorias() {
      this.categoriaEditSelected = [];
      this.selectedCategoriasFinal = [];
      this.categoriasRenderizadas = [];
    },
    validateForm() {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.procesarUnificacion();
        } else {
          this.$validator.validate();
        }
      });
    },
    eliminarCategoria(categoria) {
      this.axios.delete(`/categorias/${categoria.id}`).then((response) => {
        this.isDelete = false;
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "success",
          text: "Categoría eliminada",
          icon: "mdi-check",
          timeout: 3000,
        });
        this.refreshCategoriaEditada(categoria);
      });
    },
    procesarUnificacion() {
      const payload = {
        categoria_ids: this.selectedCategoriasFinal.map((c) => c.id),
        nuevo_nombre: this.nuevoNombreCategoria,
      };
      console.log(payload);

      CategoriaAPI.unificar(payload)
        .then((response) => {
          let message =
            response.data.detail || "Categorías unificadas con éxito.";
          console.log(message);

          this.$updateBus.$emit("showSnackBar", {
            show: true,
            button: false,
            color: "success",
            text: "" + message,
            icon: "mdi-check",
            timeout: 3000,
          });

          // Limpiar selección y diálogo
          this.nuevoNombreCategoria = "";
          this.selectedCategoriasFinal = [];
          this.isUnificar = false;

          // Limpiar lista y recargar categorías desde la raíz
          this.categoriasRenderizadas = [];
          this.loadCategoriasIniciales(); // recarga la lista completa
          // this.fetchCategoria(response.data.nueva_categoria);
        })
        .catch((error) => {
          console.log(error);

          this.$updateBus.$emit("showSnackBar", {
            show: true,
            button: false,
            color: "red",
            text:
              error.response?.data?.detail || "Error al unificar categorías",
            icon: "mdi-alert-circle",
            timeout: 3000,
          });
        });
    },

    removeCategoria(categoria) {
      this.selectedCategoriasFinal = [];
    },

    fetchCategoria(categoria) {
      console.log(categoria);

      this.loadingCategoriaSelected = true;
      var componentes = this.categoriasRenderizadas;
      console.log(componentes);

      // Elimina los componentes que estan despues del que se va a crear
      for (let index = 0; index < componentes.length; index++) {
        const element = componentes[index];

        if (categoria.mptt_level < element.categoria.level_padre + 1) {
          console.log("splice", index);

          this.categoriasRenderizadas.splice(index);
        }
      }
      var global = true
      console.log(global);
      
      ProductosApi.indexCategorias(categoria.name, global).then((response) => {
        console.log(response);

        this.categoriasRenderizadas.push({
          type: ProductoCategoriasTreeBranch,
          categoria: {
            level_padre: response.data.parent.mptt_level,
            categorias: response.data.parent.children,
            nombre_padre: response.data.parent.name,
            id: response.data.parent.id,
          },
        });

        this.loadingCategoriaSelected = false;

        this.$nextTick(() => {
          const container = this.$refs.scrollContainer;
          if (container) {
            container.scrollTo({
              left: container.scrollWidth,
              behavior: "smooth",
            });
          }
        });
      });
    },

    loadCategoriasIniciales() {
      this.loadingCategoriaSelected = true;
      const name = this.$route.params.padre;
      console.log(name);

      ProductosApi.indexCategorias(name, true).then((response) => {
        this.categoriaPadre = response.data.parent;
        console.log(response.data.parent);
        
        this.categoriasRenderizadas.push({
          type: ProductoCategoriasTreeBranch,
          categoria: {
            level_padre: response.data.parent.mptt_level,
            categorias: response.data.parent.children,
            nombre_padre: response.data.parent.name,
            id: response.data.parent.id,
          },
          id: this.count++,
        });
        this.loadingCategoriaSelected = false;
      });
    },
  },
  watch: {
    isDelete(val) {
      if (!val) this.confirmDelete = false;
    },
    isImagen(val) {
      if (!val) this.imagenFile = null;
    },
  },
  created() {
    this.loadCategoriasIniciales();
  },
};
</script>
<style scoped>
.toolbar-seleccion >>> .v-toolbar__content {
  flex-wrap: wrap;
  min-height: 56px;
  padding-top: 4px;
  padding-bottom: 4px;
}
@media (max-width: 599px) {
  .scroll-bar {
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
  }
  .columna-nivel {
    scroll-snap-align: start;
  }
}
.scroll-bar {
  /* align-items: stretch;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap; */
  overflow-x: auto;
  overflow-y: hidden;
}
</style>
